import React, { useEffect } from "react";
import { Helmet } from "react-helmet";
import styled from "@emotion/styled";
import BulkHeader from "@components/BulkHeader";
import { ClearedStyleHref } from "@modules/Components";
import "../styles/giving.scss";
import { useDispatch } from "react-redux";
import { initAppBrowser } from "@actions/initApp";

const MainContent = styled.div`
  padding-top: 8%;
  padding-bottom: 8%;

  @media (max-width: 630px) {
    padding-top: 100px;
    padding-bottom: 100px;
  }
  @media (max-width: 625px) {
    width: 100%;
    overflow: hidden;
  }
`;

const AboutContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 299px 0.3fr;

  @media (max-width: 1720px) {
    grid-template-columns: 0.9fr 260px 0.4fr;
  }
  @media (max-width: 1320px) {
    grid-template-columns: 0.8fr 268px 0.5fr;
  }
  @media (max-width: 1150px) {
    grid-template-columns: 1fr;
    padding-top: 45px;
  }
  @media (max-width: 425px) {
    padding-top: 5px;
  }
`;

const GivingImageContainer = styled.div`
  grid-column: 1/3;
  grid-row: 1/2;

  @media (max-width: 1150px) {
    grid-row: 2/3;
    grid-column: 1/2;
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
  }
  @media (max-width: 625px) {
    overflow: visible;
  }
`;

const GivingImage = styled.img`
  width: 100%;

  @media (max-width: 1350px) {
    position: relative;
    right: 55px;
  }
  @media (max-width: 1200px) {
    right: 64px;
  }
  @media (max-width: 1150px) {
    right: -14%;
    margin-top: 40px;
    max-width: 868px;
  }
  @media (max-width: 1000px) {
    right: -18%;
  }
  @media (max-width: 625px) {
    max-width: none;
    width: 114%;
  }
  @media (max-width: 425px) {
    width: 137%;
    right: -25%;
  }
  @media (max-width: 350px) {
    width: 153%;
    right: -27%;
  }
`;

const AboutTextContainer = styled.div`
  grid-column: 2/4;
  grid-row: 1/2;

  @media (max-width: 1150px) {
    grid-row: 1/2;
    grid-column: 1/2;
    text-align: center;
  }
  @media (max-width: 625px) {
    width: 90%;
    margin: 0 auto;
  }
`;

const PurpleLine = styled.div`
  width: 36px;
  height: 3px;
  border-radius: 1.5px;
  background-color: #eb68d0;
  margin: ${props => (props.margin0 ? "0 auto" : "")};

  @media (max-width: 1150px) {
    margin: 0 auto;
  }
`;

const AboutHeader = styled.h2`
  font-size: 48px;
  line-height: 1.5;
  color: #1f2021;
  margin-bottom: 41px;
  margin-top: 25px;

  @media (max-width: 1500px) {
    font-size: 45px;
    margin-bottom: 35px;
    margin-top: 22px;
  }
  @media (max-width: 1320px) {
    font-size: 45px;
    margin-bottom: 18px;
    margin-top: 16px;
  }
  @media (max-width: 500px) {
    font-size: 41px;
    margin-bottom: 13px;
  }
  @media (max-width: 425px) {
    font-size: 35px;
  }
  @media (max-width: 350px) {
    font-size: 30px;
  }
`;

const AboutText = styled.div`
  font-size: 18px;
  line-height: 2;
  color: #777984;
  margin-bottom: 14px;

  @media (max-width: 1850px) {
    font-size: 17px;
  }
  @media (max-width: 1500px) {
    font-size: 16px;
    line-height: 1.9;
  }
  @media (max-width: 1150px) {
    font-size: 17px;
    max-width: 62%;
    margin: 0 auto;
    margin-bottom: 23px;
  }
  @media (max-width: 1000px) {
    max-width: 629px;
  }
  @media (max-width: 700px) {
    max-width: 100%;
  }
  @media (max-width: 500px) {
    font-size: 16px;
    margin-bottom: 13px;
  }
`;

const BoldAboutText = styled.span`
  font-weight: 500;
  color: #1f2021;
`;

const PinkAboutText = styled.span`
  color: #eb68d0;
`;

const HowItWorksOffWhite = styled.div`
  background-color: rgba(235, 104, 208, 0.06);
  position: relative;
`;

const TopLeftImage = styled.img`
  position: absolute;
  top: -64px;

  @media (max-width: 1150px) {
    display: none;
  }
`;

const TopRightImage = styled.img`
  position: absolute;
  right: 0;

  @media (max-width: 1150px) {
    display: none;
  }
`;

const HowItWorksMain = styled.div`
  border-radius: 0px 0px 240px 0px;
  background-blend-mode: overlay, normal;
  padding-top: 100px;
  padding-bottom: 100px;
  background-image: radial-gradient(
      circle at 0 0,
      rgba(255, 255, 255, 0.1),
      rgba(255, 255, 255, 0) 74%
    ),
    linear-gradient(to bottom, #78356a, #78356a);

  @media (max-width: 530px) {
    border-radius: 0px 0px 170px 0px;
  }
  @media (max-width: 400px) {
    border-radius: 0px 0px 100px 0px;
  }
`;

const HeaderLine = styled.div`
  width: 36px;
  height: 3px;
  border-radius: 1.5px;
  margin: 0 auto;
  background-color: rgba(255, 255, 255, 0.32);
`;

const HowItWorksHeader = styled.h3`
  font-size: 48px;
  line-height: 1.5;
  text-align: center;
  color: #ffffff;
  padding-top: 33px;

  @media (max-width: 630px) {
    font-size: 40px;
  }
  @media (max-width: 530px) {
    font-size: 35px;
  }
  @media (max-width: 450px) {
    width: 90%;
    margin: 0 auto;
  }
`;

const ProcessDiv = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  margin-top: 85px;
  grid-gap: 54px;
  @media (max-width: 1375px) {
    grid-gap: 30px;
  }
  @media (max-width: 1150px) {
    grid-template-columns: 1fr;
    width: 80%;
    grid-row-gap: 50px;
    margin-top: 55px;
  }
`;

const HowContainer = styled.div`
  text-align: left;
  display: grid;
  grid-template-columns: 86px 1fr;
  grid-template-rows: 72px 1fr;
  align-items: center;

  @media (max-width: 1150px) {
    display: block;
    text-align: center;
    margin: 0 auto;
    max-width: 328px;
  }
`;

const ImageContainer = styled.div`
  width: 55px;
  height: 55px;
  border-radius: 0px 0px 0px 25px;
  background-color: #78356a;
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: 29px 29px 44px 0 rgba(31, 32, 33, 0.2);

  @media (max-width: 1150px) {
    margin: 0 auto;
    width: 60px;
    height: 60px;
  }
`;

const HowImage = styled.img`
  filter: drop-shadow(0px 10px 10px rgba(251, 212, 152, 0.5));
`;

const TextHeader = styled.div`
  font-size: 21px;
  font-weight: bold;
  color: #ffffff;

  @media (max-width: 1870px) {
    font-size: 20px;
  }
  @media (max-width: 1810px) {
    font-size: 19px;
  }
  @media (max-width: 1500px) {
    font-size: 18px;
  }
  @media (max-width: 1330px) {
    font-size: 17px;
  }
  @media (max-width: 1260px) {
    font-size: 16px;
  }
  @media (max-width: 1150px) {
    font-size: 24px;
    margin-top: 29px;
    margin-bottom: 22px;
  }
  @media (max-width: 450px) {
    font-size: 18px;
  }
  @media (max-width: 340px) {
    font-size: 17px;
  }
`;

const TextContainer = styled.div`
  font-size: 17px;
  line-height: 1.9;
  color: rgba(255, 255, 255, 0.8);
  align-self: flex-start;

  @media (max-width: 1820px) {
    font-size: 16px;
    line-height: 1.8;
  }
  @media (max-width: 1330px) {
    font-size: 15px;
  }
  @media (max-width: 1260px) {
    font-size: 14px;
  }
  @media (max-width: 1150px) {
    font-size: 16px;
  }
`;

const SalesmanMainContainer = styled.div`
  position: relative;
  min-height: 664px;
  @media (max-width: 1150px) {
    min-height: auto;
  }
`;

const BottomLeftImage = styled.img`
  position: absolute;
  max-height: 100%;

  @media (max-width: 1150px) {
    display: none;
  }
`;

const Salesman = styled.div`
  display: grid;
  width: 60%;
  grid-template-columns: 1fr 1fr;
  grid-gap: 160px;
  margin: 0 auto;
  padding-top: 215px;
  padding-bottom: 121px;

  @media (max-width: 1500px) {
    width: 75%;
    grid-gap: 100px;
  }
  @media (max-width: 1150px) {
    grid-gap: 57px;
  }
  @media (max-width: 915px) {
    grid-gap: 0px;
    width: 100%;
  }
  @media (max-width: 630px) {
    grid-template-columns: 1fr;
    padding-top: 168px;
  }
`;

const PictureContainer = styled.div`
  text-align: center;
  width: 350px;
  height: 435px;
  margin: 0 auto;
  background-blend-mode: overlay, normal;
  background-image: radial-gradient(
      circle at 0 0,
      #ffffff,
      rgba(255, 255, 255, 0) 76%
    ),
    linear-gradient(to bottom, #78356a, #78356a);

  @media (max-width: 1150px) {
    width: 305px;
  }
  @media (max-width: 315px) {
    width: 100%;
  }
`;

const PictureInnerContainer = styled.div`
  width: 70%;
  margin: 0 auto;

  @media (max-width: 1150px) {
    width: auto;
  }
`;

const SalesmanImage = styled.img`
  width: 120px;
  height: 120px;
  margin-top: -65px;

  @media (max-width: 1150px) {
    margin-top: -56px;
  }
`;

const SalesmanName = styled.div`
  font-size: 18px;
  font-weight: bold;
  color: #ffffff;
  margin-top: 33px;
  margin-bottom: 28px;

  @media (max-width: 1150px) {
    margin-top: 37px;
  }
`;

const SalesmanStatement = styled.div`
  font-size: 16px;
  line-height: 1.88;
  color: rgba(31, 32, 33, 0.6);
  width: 262px;
  margin: 0 auto;
  margin-bottom: 52px;
  color: rgba(255, 255, 255, 0.8);
  @media (max-width: 1150px) {
    width: 237px;
    margin-bottom: 41px;
  }
`;

const LinkContainer = styled.div`
  display: flex;
  justify-content: center;
  color: #eb68d0;
  background-color: #ffffff;
  border-radius: 36px;
  width: 226px;
  height: 72px;
  margin: 0 auto;
`;

const Href = styled(ClearedStyleHref)`
  width: 100%;
  height: 72px;
  border-radius: 36px;
  font-size: 16px;
  font-weight: bold;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  background-color: #ffffff;
  font-size: 16px;
  color: #eb68d0;
  &:hover {
    background-color: rgba(235, 104, 208, 0.16);
  }

  @media (max-width: 1150px) {
    margin: 0 auto;
  }
`;

const MeetUs = styled.div`
  text-align: left;

  @media (max-width: 1150px) {
    text-align: center;
    padding-top: 0;
  }
  @media (max-width: 915px) {
    max-width: 340px;
  }
  @media (max-width: 800px) {
    margin-right: 40px;
    margin-left: 20px;
  }
  @media (max-width: 630px) {
    grid-row: 1/2;
    max-width: 90%;
    margin: 0 auto;
    margin-bottom: 126px;
  }
`;

const HeaderLineCenteredMobile = styled(HeaderLine)`
  background-color: #eb68d0;
  margin: 0;

  @media (max-width: 1150px) {
    margin: 0 auto;
  }
`;

const MeetUsHeaderLineCenteredMobile = styled(HeaderLineCenteredMobile)`
  @media (max-width: 1150px) {
    margin-top: -56px;
  }
`;

const MeetHeader = styled.div`
  font-size: 48px;
  line-height: 1.5;
  color: #1f2021;
  margin-top: 33px;
  margin-bottom: 40px;

  @media (max-width: 1500px) {
    font-size: 42px;
    margin-top: 30px;
    margin-bottom: 35px;
  }
  @media (max-width: 1150px) {
    font-size: 36px;
    line-height: 1.67;
  }
  @media (max-width: 630px) {
    font-size: 30px;
  }
`;

const MeetP = styled.div`
  font-size: 18px;
  line-height: 2;
  color: #777984;
  width: 434px;
  margin-bottom: 15px;

  @media (max-width: 1500px) {
    width: 100%;
    max-width: 448px;
  }
  @media (max-width: 1400px) {
    font-size: 17px;
  }
  @media (max-width: 767px) {
    font-size: 16px;
  }
  @media (max-width: 680px) {
    font-size: 15px;
  }
  @media (max-width: 630px) {
    max-width: none;
  }
`;

const howItWorksArray = [
  {
    id: 1,
    header: "Champions of your Cause",
    text: "Because it costs shoppers nothing (literally) to support your cause, they are more inclined to do so and to encourage their friends to do so.",
    image: "https://cdn.cardcash.com/website/ui/giving/group-icon.svg"
  },
  {
    id: 2,
    header: "Increase Donations",
    text: 'An "always on" donation mode enables you to generate more donations without making one solicitations.',
    image: "https://cdn.cardcash.com/website/ui/giving/cash-white.svg"
  },
  {
    id: 3,
    header: "Stay Top of Mind",
    text: "Great causes remain at the top-of-mind of shoppers with every gift card purchased. Shoppers respect and appreciate brands who are giving conscious.",
    image: "https://cdn.cardcash.com/website/ui/giving/support.svg"
  }
];

const Giving = () => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(initAppBrowser(["messages"]));
  }, []);
  const shareLink = "https://share.hsforms.com/1BqfHjWlnTdacVK31M6Ot8g16lpr";
  return (
    <div className="mar-t-125 giving-main">
      <Helmet
        title={
          "CardCash Giving helps charities and other causes get donations without any out of pocket expenses."
        }
        meta={[
          {
            name: "description",
            content:
              "CardCash Giving creates a customized app for each of our partners and their specific cause. eGift cards are purchased through the app and delivered to the consumer immediately. Getting donations for charities and causes, without shoppers spending a thing (well, almost)."
          }
        ]}
      />
      <div>
        <BulkHeader
          buttonText={"Learn more"}
          classFromParent={"giving-header"}
          headerOne={"They Shop."}
          headerTwo={"You Gain."}
          text={
            "What’s better than getting donations for your charity or cause? Getting donations without doing a thing. With CardCash Giving, supporters of your cause can shop guilt-free (well, almost guilt free). Because while it can’t excuse their midnight shopping spree it can make them feel great about supporting a cause that is meaningful to them."
          }
          image={
            "https://cdn.cardcash.com/website/ui/giving/hero-phone-app.png"
          }
          shareLink={shareLink}
          noPeriod={true}
        />
        <MainContent className={"main-container-page-width"}>
          <AboutContainer>
            <GivingImageContainer>
              <GivingImage
                src="https://cdn.cardcash.com/website/ui/giving/giving-mockups4.png"
                alt=""
              />
            </GivingImageContainer>
            <AboutTextContainer>
              <PurpleLine />
              <AboutHeader>How does it work?</AboutHeader>
              <AboutText>
                CardCash creates a customized app for each of our partners and
                their specific cause.
                <BoldAboutText>
                  &nbsp;eGift cards are purchased through the app for the exact
                  amount of the purchase, and delivered to the consumer
                  immediately. eGift cards are redeemable in-store, at checkout,
                  or online and in-app.
                </BoldAboutText>
              </AboutText>
              <AboutText>
                Through this platform we’ve already helped families pay down
                student loan debt, contributed to research and awareness for
                childhood illnesses, improved heart health, and so much more.
              </AboutText>
              <AboutText>
                We’re proud to be partnering with
                <PinkAboutText>
                  &nbsp;St. Jude Children's Research Hospital&nbsp;
                </PinkAboutText>
                and<PinkAboutText>&nbsp;Gift of College</PinkAboutText>.
              </AboutText>
            </AboutTextContainer>
          </AboutContainer>
        </MainContent>
        <div>
          <HowItWorksOffWhite>
            <TopLeftImage
              src="https://cdn.cardcash.com/website/ui/bulk/grey-left.svg"
              alt=""
            />
            <TopRightImage
              src="https://cdn.cardcash.com/website/ui/bulk/grey-right.svg"
              alt=""
            />
            <HowItWorksMain>
              <HeaderLine />
              <HowItWorksHeader>Be a part of the change</HowItWorksHeader>
              <ProcessDiv className="main-container-page-width">
                {howItWorksArray.map((item, index) => (
                  <HowContainer key={index}>
                    <ImageContainer>
                      <HowImage src={item.image} alt="" />
                    </ImageContainer>
                    <TextHeader>{item.header}</TextHeader>
                    <div />
                    <TextContainer>{item.text}</TextContainer>
                  </HowContainer>
                ))}
              </ProcessDiv>
            </HowItWorksMain>
            <SalesmanMainContainer>
              <BottomLeftImage
                src="https://cdn.cardcash.com/website/ui/giving/left-elements.svg"
                alt=""
              />
              <Salesman>
                <PictureContainer>
                  <PictureInnerContainer>
                    <SalesmanImage
                      src="https://cdn.cardcash.com/website/ui/exchange_lp/joerice-headshot2.png"
                      alt=""
                    />
                    <SalesmanName>Joe Rice</SalesmanName>
                    <SalesmanStatement>
                      As Director of Business Development, Joe loves to figure
                      out how discounted gift cards can help brands grow.
                    </SalesmanStatement>
                    <LinkContainer>
                      <Href
                        className={"button-transition-hover-bgColor-color"}
                        href={shareLink}
                        target="_blank"
                      >
                        Let's talk
                      </Href>
                    </LinkContainer>
                  </PictureInnerContainer>
                </PictureContainer>
                <MeetUs>
                  <MeetUsHeaderLineCenteredMobile />
                  <MeetHeader>Just ask Joe</MeetHeader>
                  <MeetP>
                    Joe loves paying it forward, which is exactly what he tells
                    his wife when she asks about the abundance of power tools he
                    just bought himself. But even more so, he loves helping our
                    customers connect to great causes like yours
                  </MeetP>
                  <MeetP>
                    So just shoot Joe an email and Joe and his team will help
                    you figure out how discounted gift cards can help your
                    charity/cause.
                  </MeetP>
                </MeetUs>
              </Salesman>
            </SalesmanMainContainer>
          </HowItWorksOffWhite>
        </div>
      </div>
    </div>
  );
};

export default Giving;
